var __rspack_ns_object = JSON.parse('{"No results.":"Test No results.","Not enough room to display this column":"Test Not enough room to display this column"}')